module.exports = __webpack_public_path__ + "components/flag/static/square/tg-c936db29ca8501641ea3ac960d4ac9f5.svg";